import React from 'react';
import If from '../../If/If';
import { isNotNullOrUndefined, stringIsEmpty } from '../../../../Util/TypeGuards';
import { Button } from 'Views/Components/Button/Button';

export interface AccountDetailsTabHeaderProps {
	headerText: string;
	buttonText?: string;
	onClick?: () => void;
	secondaryButtonText?: string;
	onSecondaryClick?: () => void;
}

export function AccountDetailsTabHeader({
	headerText,
	buttonText,
	onClick,
	secondaryButtonText,
	onSecondaryClick,
}: AccountDetailsTabHeaderProps) {
	return (
		<div className="account-details-tab-header">
			<h4>{headerText}</h4>
			<div className="account-details-tab-header__actions">
				<If condition={!stringIsEmpty(secondaryButtonText) && isNotNullOrUndefined(onSecondaryClick)}>
					<Button
						buttonProps={
							{
								id: 'convert-guest-button',
								'data-test-id': 'account-convert-guest-button',
							} as any
						}
						onClick={onSecondaryClick}
					>
						{secondaryButtonText}
					</Button>
				</If>
				<If condition={!stringIsEmpty(buttonText) && isNotNullOrUndefined(onClick)}>
					<Button
						buttonProps={{
							id: 'edit-button',
						}}
						onClick={onClick}
					>
						{buttonText}
					</Button>
				</If>
			</div>
		</div>
	);
}
